import React, { useState } from "react";
import moment from "moment/moment";
import Status from "../../../../Utils/Status/Status";
import { Dialog } from "primereact/dialog";
import Sharing from "./Sharing/Sharing";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");

export default function ListCard(props) {
  const admin = props.admin;

  const item = props.item;

  const [sharing, setSharing] = useState(false);

  const OpenEdit = () => {
    window.user_id = item.id;
    window.openeditSuper();
  };

  const OpenSharing = () => {
    setSharing(true);
  };

  const handleCopyMsg = () => {
    const msg = `
Welcome To ${window.APP_NAME}

Name : ${item.name}  
Super User Username : ${item.username}
Super User Password : ${"123123" || "*****"}

Platform: ${window.WEBSITE_LINK}`;

    navigator.clipboard.writeText(msg);
    toast.success("Copied user message");
  };

  return (
    <div onDoubleClick={handleCopyMsg} className="menuContainer addHight text">
      <div onClick={OpenEdit} className="menuUsername">
        <div className="user_id">{item.username}</div>
      </div>
      <div
        className={`menuUsername ${
          item.profit_loss > 0 ? "buytext" : "selltext"
        }`}
      >
        {fmt.format(parseFloat(item.profit_loss).toFixed(0))}
      </div>
      <div
        className={`menuUsername ${
          item.net_profit_loss > 0 ? "buytext" : "selltext"
        }`}
      >
        {fmt.format(parseFloat(item.net_profit_loss).toFixed(0))}
      </div>
      <div onClick={OpenSharing} className={`menuName `}>
        <div className="user_id">{fmt.format(item.sharing)}</div>
      </div>
      <div className={`menuName `}>{item.tpassword}</div>
      <div className="menuName">
        <Status id={item.id} status={item.trade} type="TRADE" />
      </div>
      <div className="menuName">
        <Status id={item.id} status={item.only_sq} type="ONLY_SQ" />
      </div>
      <div className="menuName">
        <Status id={item.id} status={item.status} type="STATUS" />
      </div>
      <div className="menuName">{item.ip == null ? "N/A" : item.ip}</div>
      {/* Dates */}
      <div className="menuDate flex flex-col items-center justify-center">
        <div className="extraSmall">
          {moment(item.date_created).format("DD-MM-YYYY")}
        </div>
        <div className="small">
          {moment(item.date_created).format("HH:mm:ss")}
        </div>
      </div>

      <div className="menuDate small flex flex-col items-center justify-center">
        {item.last_login_date ? (
          <>
            <div className="extraSmall">
              {moment(item.last_login_date).format("DD-MM-YYYY")}
            </div>
            <div className="small">
              {moment(item.last_login_date).format("HH:mm:ss")}
            </div>
          </>
        ) : (
          "N/A"
        )}
      </div>
      <div className="menuName">
        <button
          onClick={OpenEdit}
          className="dropbtnNavSub marginright white primary"
        >
          EDIT
        </button>
      </div>

      <Dialog
        visible={sharing}
        closeOnEscape
        closeIcon
        onHide={() => {
          setSharing(false);
        }}
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <Sharing
          item={item}
          close={() => setSharing(false)}
          reload={props.reload}
          admin={admin}
        />
      </Dialog>
    </div>
  );
}
